module.exports = __webpack_public_path__ + "static/media/meetup1.43d4e1fc.png";